var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fatcher" }, [
    _c("div", { staticClass: "header" }, [
      _c(
        "div",
        {
          staticClass: "content",
          staticStyle: { height: "500px", width: "120%" }
        },
        [
          !_vm.forgetPassword
            ? _c("div", { staticClass: "left" }, [
                _c("img", {
                  staticStyle: { height: "500px" },
                  attrs: { src: require("@/assets/login-left.png") }
                })
              ])
            : _vm._e(),
          _c(
            "div",
            {
              class: ["user-layout-wrapper", _vm.device],
              attrs: { id: "userLayout" }
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c("div", { staticClass: "top" }, [
                    _c("div", { staticClass: "header" }, [
                      _c("a", { attrs: { href: "/" } }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              this.$store.getters.language["common.WelcomeTo"] +
                                " " +
                                this.$store.getters.application
                                  .applicationNameLanguage
                                ? this.$store.getters.application
                                    .applicationNameLanguage
                                : this.$store.getters.application
                                    .applicationName
                            )
                          )
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "desc" })
                  ]),
                  _c("route-view")
                ],
                1
              )
            ]
          )
        ]
      )
    ]),
    _c("div", { staticClass: "footer" }, [
      _c("div", { staticClass: "copyright" }, [
        _vm._v(
          "\n      Copyright © " +
            _vm._s(_vm.language["common.copyright.year"]) +
            " " +
            _vm._s(_vm.language["portal.ui2.copyright"]) +
            " "
        ),
        _c("br"),
        _c(
          "a",
          {
            staticStyle: { "padding-left": "5px" },
            attrs: {
              target: "_blank",
              href: "https://beian.miit.gov.cn/#/Integrated/recordQuery"
            }
          },
          [_vm._v(_vm._s(_vm.language["common.copyright.filing"]))]
        ),
        _c("br"),
        _vm._v(
          "\n      " +
            _vm._s(_vm.language["portal.ui2.contactEmail"]) +
            ": xiao-jun.ding@foxconn.com\n    "
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }